import { get,postP,uploadOther } from '@/utils/axios'

export default {
    
    // 用户登录
    signInAsync(data){
        return get('OAuth/SignInAsync',data)
    },
    // 用户注册
    register(data){
        return get('OAuth/Register',data)
    },
    sendCode(data){
        return get('OAuth/SendCode/'+data)
    },
    // 上传
    uploadFile(file,params){
        return uploadOther('',file,params)
    },
}